import React from 'react'
import { UseFormReturn } from 'react-hook-form';
import TextEditor from '../../../FormEditors/TextEditor';
import { VirtualMedicine } from '../../../../apis/virtual-medicines/types';

interface VirtualMedicineFormEditorProps {
  form: UseFormReturn<VirtualMedicine>;
}

const VirtualMedicineFormEditor = ({ form }: VirtualMedicineFormEditorProps) => {
  return <TextEditor label="Form" control={form.control} name="form" />;
};

export default VirtualMedicineFormEditor;
